import { EntityIconToken } from "../api";
import { iconsSchemas } from "../config/entities";

export type IconDefinition = {
  label: string;
  name: string;
  render: () => JSX.Element;
};

export const isCustomEntityIconToken = (
  icon: string,
): icon is EntityIconToken => {
  return icon in iconsSchemas;
};
